import { Model } from "@bryntum/schedulerpro";


export class NotifyPreferences extends Model {
  static get $name() {
    return "NotifyPrefrences"
  }

  static get fields() {
    return [
      // notifyType will be one of ALERT_TYPES defined in OtherKeys.jsx file
      {name: "userId", dataSource: "user_id", type: "number"},
      {name: "notifyType", dataSource: "notify_type", type: "number"},
      {name: "isEmailNotify", dataSource: "is_email_notify", type: "boolean"},
      {name: "isWorkforceNotify", dataSource: "is_workforce_notify", type: "boolean"},
      {name: "bannerNotify", dataSource: "banner_notify", type: "number"},
      {name: "interupt", dataSource: "is_interrupt", type: "boolean"},
      {name: "order", dataSource: "order", type: "number"}
    ]
  }
}

NotifyPreferences.exposeProperties();